<template>
    <div class="checkoutpage thankyoupage">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <header>
            <div class="container">
                <div class="carthead">
                    <div class="cartlogosec">
                        <a href="/"><b-img class="logo" src="/shop/images/rmcoco_new.webp" alt="Photo camera image"></b-img></a>
                    </div>
                    
                    <router-link class="backcart" to="/shop/products/fabric"><b-img class="backarrow" src="/shop/images/cart.svg" fluid alt="cart image"></b-img> Continue Shopping</router-link>
                </div>
            </div>
        </header>
        <div class="maincart">
            <div class="leftcart">
                <div class="thankyou" v-if="this.$route.params.order_id == '1'">
                    <div class="checkmark">
                        <b-img class="check_img" src="/shop/images/check.svg" fluid alt="checkmark image"></b-img>
                    </div>
                    <div class="orderthank">
                        <span>&nbsp;</span>
                        <h1>Thank you!</h1>
                    </div>
                    <h3>Your quote will be send.</h3>
                    <p>We will send the quote on your email address shortly.</p>
                    <hr>
                    <div class="customer_info">
                        <b-button  href="/shop/products/fabric"  variant="dark">Continue Shopping</b-button>                  
                    </div>
                </div>
                <div class="thankyou" v-else>
                    <div class="checkmark">
                        <b-img class="check_img" src="/shop/images/check.svg" fluid alt="checkmark image"></b-img>
                    </div>
                    <div class="orderthank">
                        <span>Order #{{orderdetails.salesid}}</span>
                        <h1>Thank you {{user.firstname}}!</h1>
                    </div>
                    <h3>Your order has been received.</h3>
                    <p v-if="this.$route.query.mailmsg == '0'">Unfortunately we were not able to send your confirmation at this time. If you need a copy of your confirmation, please contact customer service with your #{{orderdetails.salesid}} at customerservice@rmcoco.com.</p>
                    <hr>
                    <div class="customer_info">
                        <h3>Customer Information</h3>
                        <div class="billship">
                            <div class="ship_ad">
                                <h4>Shipping Address</h4>
                                <address>
                                    {{orderdetails.DELIVERYNAME}}<br/>
                                    {{orderdetails.Del_street}}<br/>
                                    {{orderdetails.Del_City}}, {{orderdetails.Del_State}} {{orderdetails.Del_zip}}<br/>
                                    {{orderdetails.Del_Country}}
                                </address>
                                <h4>Shipping Method</h4>
                                <p>{{orderdetails.SHIPPINGMETHODTEXT}}</p>
                            </div>
                            <div class="bill_ad">
                                <h4>Billing Address</h4>
                                <address>
                                    {{orderdetails.NAME}}<br/>
                                    {{orderdetails.STREET}}<br/>
                                    {{orderdetails.CITY}}, {{orderdetails.STATE}} {{orderdetails.ZIPCODE}}<br/>
                                    {{orderdetails.COUNTRYREGIONID}}
                                </address>
                            </div>
                        </div>
                        <b-button  href="/shop/products/fabric"  variant="dark">Continue Shopping</b-button>
                        <b-button class="thank-order"  href="/shop/orders"  variant="dark">My Orders</b-button>
                    </div>
                </div>
            </div>
			<a @click="toggleorder" class="ordershow" href="#">Order Summary<b-img class="plusfil" src="/shop/images/add.svg" alt="add"></b-img><b-img class="minusfil" src="/shop/images/minus.svg" alt="minus"></b-img></a>
            <div class="rightcart">
                <div class="cartproducts">
                    <div class="innerproducts" v-for="(item, ik) in orderdetails.items" :key="ik">
                        <div class="prdimg">
                            <b-img :src="item.SMALL_IMAGE" fluid alt="project image"></b-img>
                        </div>
                        <div class="prdcont">
                            <h3>
                                <span v-if="orderdetails.ORDERTYPE == 'CDI'">{{item.ItemName}}</span>
                                <span v-else>{{item.ItemName}} - {{item.COLORNAME}}</span>
                                <span class="cartprice">${{item.LINEAMOUNT}}</span>
                            </h3>
                            <div class="samediv">
                                <span>ID: </span>
                                <p>{{item.ITEMID}}-{{item.INVENTCOLORID}}</p>
                            </div>
                            <div class="samediv">
                                <span>Type: </span>
                                <p>{{orderdetails.ORDERTYPE}}</p>
                            </div>
                            <div class="samediv">
                                <span>Price: </span>
                                <p>{{item.DISCSALESPRICE}}</p>
                            </div>
                            <div class="samediv">
                                <span>Qty: </span>
                                <p>{{item.salesqty}}</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
                 <div class="rightinner">
                      <div class="cartvalue" v-if="this.$route.params.order_id != '1'">
                          <span>Sub Total</span>
                          <p>${{orderdetails.SUBTOTAL}}</p>
                      </div>
                      <div class="cartvalue" v-if="this.$route.params.order_id != '1'">
                          <span>Shipping</span>
                          <p>{{orderdetails.shipping > 0 ? "$"+orderdetails.shipping : "TBD"}}</p>
                      </div>
                      <div class="cartvalue totalvalue" v-if="this.$route.params.order_id != '1'">
                          <span>Total</span>
                          <p>${{orderdetails.TOTAL}}</p>
                      </div>
                      <div class="help_signup">
                          <p>Need Help with this order?</p>
                          <b-button @click="callusTrigger" variant="outline-primary" squared v-html="callustext"></b-button>
                          <b-button @click="emailusTrigger" variant="outline-primary" squared><b-img src="/shop/images/mail.svg" class="mailblack"></b-img><b-img src="/shop/images/mail-white.svg" class="mailwhite"></b-img>Email Us</b-button>
                      </div>
                  </div>
            </div>
        </div>
        <footer>
            <div class="container">
                <div class="footlink">
                    <ul>
                        <li><router-link to="/terms-of-services/">Terms of Sevices</router-link></li>
                        <li><router-link to="/privacy-policy/">Privacy Policy</router-link></li>
                    </ul>
                    <p class="copyright_text">© 1980 - {{ new Date().getFullYear() }} RM COCO</p>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ResourceMixin from "../mixins/resources";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    components: {
        Loading
    },
    mixins: [ResourceMixin],
    mounted() {
        this.isLoading = true;
        if (this.$route.params.order_id != "1") {
            this.$store.dispatch("loadOrderInfo", this.$route.params.order_id).then(orderdetails => {
                this.orderdetails = orderdetails.data;
            }).catch(error => {
                this.orderdetails = []; // safely reset or show fallback
                this.$notify({
                    text: "Something went wrong! Unable to load order details.",
                    type: "error"
                });
            }).finally(() => {
                this.isLoading = false;
            });
        } else {
            this.isLoading = false;
        }
    },
    computed: {
        ...mapGetters(["user"])
    },
    data() {
        return {
            orderdetails:[],
            isLoading: false,
            callustext: '<img src="/shop/images/phone.svg" class=""><img src="/shop/images/phone-white.svg" class="whitephone"> Call Us'
        };
    },
	methods:{
	toggleorder(){
            $(".rightcart").toggle();
             $(".ordershow").toggleClass("minusshow");
		},
		callusTrigger(){
            this.callustext = "800 325 8025";
        },
        emailusTrigger(){
            window.location.href = "mailto:customerservice@rmcoco.com";
        },
	}
};
</script>
<style>
.checkoutpage.thankyoupage .backarrow{
    height: 15px;
    width: 15px;
    -webkit-transform: rotate(0); 
     transform: rotate(0);
    margin-right: 6px;
}
.thankyoupage .thankyou{
    padding: 50px 80px 215px 0;
}
.thankyoupage .thankyou .checkmark{
    border: 2px solid #d2d2d2;
    height: 58px;
    width: 58px;
    border-radius: 50%;
    float: left;
    text-align: center;
}
.thankyoupage .thankyou .checkmark .check_img{
    height: 27px;
    width: 24px;
    text-align: center;
    margin-top: 15px;
}
.thankyoupage .thankyou .orderthank{
    float: left;
    margin-left: 10px;
}
.thankyoupage .thankyou .orderthank span{
    font-size: 14px;
    color: #777;
    margin-bottom: 5px;
}
.thankyoupage .thankyou .orderthank h1{
    margin: 0;
}
.thankyoupage .thankyou h3,.thankyoupage .thankyou p{
    width: 100%;
    margin: 15px 0;
    display: inline-block;
    text-align: left;
}
.thankyoupage .thankyou p{
    margin: 0;
}
.thankyoupage .thankyou .customer_info .billship{
    display: flex;
    justify-content: left;
}
.thankyoupage .thankyou .customer_info h3{
    margin-bottom: 30px;
}
.thankyoupage .thankyou .customer_info .billship .ship_ad,.thankyoupage .thankyou .customer_info .billship .bill_ad{
    width:30%;
    margin-right: 30px;
}
.thankyoupage .thankyou .customer_info .billship .bill_ad{
    margin-right: 0;
}
.thankyoupage .thankyou .customer_info .billship h4{
    font-size: 14px;
    color: #777777 !important;
    text-align: left;
    margin-bottom: 10px;
    font-weight: normal;
}
.thankyoupage .thankyou .customer_info .billship address{
    font-size: 14px;
    color:#303030;
    line-height: 24px;
    margin-bottom: 30px;
}
.thankyoupage .thankyou .customer_info .billship p{
    font-size: 14px;
    color:#303030;
}
.thankyoupage .thankyou .customer_info .btn-dark{
    width: 225px;
    margin-top: 30px;
}
.thankyoupage .thankyou .customer_info .btn-dark.thank-order{
    width: 200px;
    margin-left: 20px;
}
@media only screen and (max-width:1024px) and (min-width:768px){
	.thankyoupage .thankyou {
		padding: 50px 0 275px 0;
	}
}
@media only screen and (max-width:767px){
	.thankyoupage .thankyou {
		padding: 50px 0 50px 0;
	}
	.thankyoupage .thankyou .checkmark{
		float: none;
		text-align: center;
		margin: 0 0 20px 0;
	}
	.thankyoupage .thankyou .orderthank span{
		text-align: left;
		display: inline-block;
		width: 100%;
	}
	.thankyoupage .thankyou .orderthank {
		float: none;
		margin-left: 0;
		text-align: center;
	}
	.thankyoupage .thankyou .customer_info .billship .ship_ad, .thankyoupage .thankyou .customer_info .billship .bill_ad{
		width:50%;
	}
	.thankyoupage .thankyou .customer_info .btn-dark {
		width: 180px;
	}
	.thankyoupage .thankyou .customer_info .btn-dark.thank-order {
		width: 130px;
	}
}
</style>